import React, {useRef} from 'react';
import {Icons} from '../../assets';

interface VideoUploadProps {
  videoFile?: File | null;
  existingVideoUrl?: string | null;
  onVideoUpload: ((file: File) => void) | ((fileName: string, file: File) => void);
  onRemoveVideo: () => void;
  className?: string;
}

export const VideoUpload: React.FC<VideoUploadProps> = ({videoFile, existingVideoUrl, onVideoUpload, onRemoveVideo, className = ''}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file && file.type.startsWith('video/')) {
      if (onVideoUpload.length === 2) {
        (onVideoUpload as (fileName: string, file: File) => void)(file.name, file);
      } else {
        (onVideoUpload as (file: File) => void)(file);
      }
    }
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div className={className}>
      <input ref={fileInputRef} type="file" accept="video/*" className="hidden" onChange={handleFileChange} />

      {videoFile || existingVideoUrl ? (
        <div className="relative">
          <div className="border-2 border-gray-300 rounded-xl overflow-hidden h-64 bg-black">
            <video
              controls
              className="w-full h-full object-contain"
              src={videoFile ? URL.createObjectURL(videoFile) : existingVideoUrl || ''}
              poster="">
              Your browser does not support the video tag.
            </video>
          </div>
          <button
            onClick={onRemoveVideo}
            className="absolute top-3 right-3 bg-white bg-opacity-90 hover:bg-opacity-100 rounded-full p-2 shadow-lg transition-all"
            title="Remove video"
            type="button">
            <img src={Icons.TRASH} alt="Remove video" className="w-4 h-4 text-gray-600" />
          </button>
        </div>
      ) : (
        <div
          onClick={handleClick}
          className="border-2 border-dashed border-gray-300 rounded-lg p-12 text-center cursor-pointer hover:border-gray-400 transition-colors">
          <div className="mx-auto rounded-lg flex items-center justify-center mb-2">
            <img src={Icons.VIDEO_ICON} alt="Video upload" className="w-8 h-8" />
          </div>
          <h3 className="text-base font-medium text-gray-900 mb-2">Upload a video</h3>
          <p className="text-sm text-gray-500 mb-6">Drag & drop or click to browse</p>
        </div>
      )}
    </div>
  );
};
